import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Vehicle/Quiter/DealerNumber/${dossierId}`, method: 'GET', token: token })
}
